import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import { BsDatepickerModule} from 'ngx-bootstrap';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DataTablesModule} from 'angular-datatables';
import {SharedModule} from '../../../_shared/shared.module';
import { ChartsModule } from 'ng2-charts';
import { CommonModule } from '@angular/common';
import { Daterangepicker } from 'ng2-daterangepicker';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { ReportsComponentModule } from '../../reports-component/reports-component.module';
import { BrandDataSourceReportsComponent } from './brand-data-source-reports.component';
import { BrandDataSourceReportService } from './brand-data-source-reports.service';
const routes: Routes = [
  {
    path: '',
    component: BrandDataSourceReportsComponent,
    data: {
      title: 'Báo cáo thống kê nguồn dữ liệu'
    },
  }
];
@NgModule({
  imports: [
    ChartsModule,
    TabsModule,
    BsDatepickerModule.forRoot(),
    CommonModule,
    DataTablesModule,
    Daterangepicker,
    HttpClientModule,
    RouterModule.forChild(routes),
    AngularMultiSelectModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    ReportsComponentModule
  ],
  declarations: [BrandDataSourceReportsComponent],
  providers: [BrandDataSourceReportService]
})
export class BrandDataSourceReportsModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/brand-data-source/brand-data-source-reports.module.ts